/**
 * Review list / filters / export transformations.
 * Used by review store for getReviewsList and getReviewExport.
 */
import i18n from '@/i18n/i18n'
import { capitalize } from '@/utils/formatter.util'

export function getFiltersParams(searchFilters = []) {
  return searchFilters.reduce((filterParams, filter) => {
    if (filter.type === 'fieldValue') {
      filterParams.fields = {
        ...(filterParams.fields || {}),
        [filter.slug]: encodeURIComponent(filter.value),
      }
      return filterParams
    }
    filterParams[filter.slug] = encodeURIComponent(filter.value)
    return filterParams
  }, {})
}

export function flattenReviewList(reviewsList) {
  return reviewsList.map(review => {
    const keyValues = {}
    review.fieldsValues.forEach(keyValue => {
      if (keyValue.type === 'file') {
        keyValues[keyValue.slug] = keyValue.file
      } else {
        keyValues[keyValue.slug] = keyValue.value
      }
    })
    return {
      ...keyValues,
      createdAt: review.createdAt,
      skus: review.skus,
      tags: review.tags,
      status: review.status,
      actions: review.actions,
      links: review.links,
      id: review.id,
      identity: review.identity,
      review: review.review,
      moderation: review.moderation,
    }
  })
}

function formatReviewStaticHeaders(staticHeaders, currentFormLexicon) {
  const formattedHeaders = []
  const lexicon = currentFormLexicon || {}

  if (staticHeaders.includes('createdAt')) {
    formattedHeaders.push({
      text: i18n.t('reviews.list.table.headers.createdAt'),
      value: 'createdAt',
      type: 'date',
      options: { format: 'L LT' },
    })
  }
  if (staticHeaders.includes('tags')) {
    formattedHeaders.push({
      text: capitalize(lexicon.tags || 'tags'),
      value: 'tags',
      type: 'ChipList',
    })
  }
  if (staticHeaders.includes('skus')) {
    formattedHeaders.push({
      text: capitalize(lexicon.skus || 'skus'),
      value: 'skus',
      type: 'skus',
    })
  }
  if (staticHeaders.includes('identity')) {
    formattedHeaders.push({
      text: capitalize(lexicon.identity || 'identity'),
      value: 'identity',
      type: 'identity',
    })
  }
  if (staticHeaders.includes('review')) {
    formattedHeaders.push({
      text: capitalize(lexicon.review || 'review'),
      value: 'review',
      type: 'review',
    })
  }
  return formattedHeaders
}

export function formatReviewHeaders(headers, currentFormLexicon) {
  const formattedHeaders = formatReviewStaticHeaders(headers.static || [], currentFormLexicon)

  formattedHeaders.push(
    ...(headers.dynamic || []).map(dynamicHeader => {
      const options = { ...dynamicHeader.options }
      if (dynamicHeader.type === 'datepicker') options.format = 'L'
      return {
        text: dynamicHeader.name,
        value: dynamicHeader.slug,
        type: dynamicHeader.type,
        options,
      }
    })
  )

  formattedHeaders.push(
    { text: i18n.t('reviews.list.table.headers.status'), value: 'status', type: 'status' },
    { text: '', value: 'actions', type: 'actions' }
  )
  return formattedHeaders
}
